import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  Modal,
  DropdownItem,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import RequestManager from "../../singletons/RequestManager/RequestManager";
import Switch from "react-switch";
import ReactTable from "react-table";
import "react-table/react-table.css";
import ImageCard from "../../components/ImageCard";
export default class InventoryManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stocks: [],
      dropdownOpen: false,
      selectedStore: null,
      stores: [],
      merchantNames: [],
      storeIds: [],
      merchantName: null,
      selectedName: null,
      orderModalVisible: false,
      image: null
    };
  }

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };

  componentWillMount() {}
  componentDidMount() {
    let reloadInventory = localStorage.getItem("reloadInventory");
    if (reloadInventory === null) {
      localStorage.setItem("reloadInventory", "Y");
      window.location.reload();
    }

    this.setupInitialCondition();
    this.getMerchantDetails();
    // this.getInventory()
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.selectedStore !== null) {
  //     if (prevState.selectedStore === null) {
  //       this.getInventory();
  //     } else if (this.state.selectedStore.id !== prevState.selectedStore.id) {
  //       this.getInventory();
  //     }
  //   }
  // }

  setupInitialCondition = async () => {
    let loginMode = localStorage.getItem("loginMode");

    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    if (loginMode === "concessionaire") {
      this.setState({ storeIds: storeInformation.concessionaire });
    } else {
    }
  };

  getInventory = async merchantId => {
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getInventory",
      {
        storeId: merchantId,
        referenceName_Icontains: ""
      }
    );

    if (response.error === null) {
      this.setState({ stocks: response.data.stocks.edges });
    }

    console.log(response);
  };

  getMerchantDetails = async () => {
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getMerchantName"
    );

    if (response.error === null) {
      this.state.merchantNames.push({
        node: { name: "Select Merchant", id: "123" }
      });
      for (let i = 0; i < response.data.merchants.edges.length; i++) {
        this.state.merchantNames.push(response.data.merchants.edges[i]);
      }

      this.setState({ merchantNames: this.state.merchantNames });
    }
  };

  getStores = async merchantId => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStores",
      {
        merchantId: merchantId
      }
    );

    if (response.error === null) {
      this.setState({ stores: response.data.merchant.stores.edges });

      if (response.data.merchant.stores.edges.length > 0) {
        this.getInventory(response.data.merchant.stores.edges[0].node.id);
      }
    }
  };

  toggleImageapproved = async (stock, imageApproved) => {
    let requestManager = new RequestManager();
    let params = {
      input: {}
    };

    params.input.id = stock.node.sku.product.id;
    params.input.imageApproved = imageApproved;

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateProduct",
      params
    );

    if (response.error === null) {
      let stocks = JSON.parse(JSON.stringify(this.state.stocks));
      let updatedStock = stocks.find(stateStock => {
        return stateStock.node.sku.product.id === stock.node.sku.product.id;
      });

      updatedStock.node.sku.product.imageApproved = imageApproved;
      this.setState({ stocks: stocks });
    } else {
      alert(
        "Unable to update inventory. Please check your internet connection."
      );
    }
  };

  storeSelected = store => {
    if (this.state.selectedStore.id !== store.id) {
      this.setState({
        stocks: [],
        selectedStore: store,
        dropdownOpen: false
      });
    }
  };

  handleChange = event => {
    this.setState({ stocks: [] });

    for (let i = 0; i < this.state.merchantNames.length; i++) {
      if (this.state.merchantNames[i].node.name === event.target.value) {
        this.getStores(this.state.merchantNames[i].node.id);

        break;
      }
    }
  };
  handleIntialChange = () => {
    this.setState({ stocks: [] });

    for (let i = 0; i < this.state.merchantNames.length; i++) {
      if (this.state.merchantNames[i].node.name === this.state.selectedName) {
        this.getStores(this.state.merchantNames[i].node.id);

        break;
      }
    }
  };
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Row noGutters>
          <Col xs="12">
            <Card
              style={{
                display: "flex",
                color: "black"
              }}
            >
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <h5>Your inventory</h5>
                {this.renderStorePicker()}
              </CardHeader>

              <div style={{ padding: 10 }}>
                <select onChange={this.handleChange}>
                  {this.state.merchantNames.map(names => (
                    <option>{names.node.name}</option>
                  ))}
                </select>
              </div>
              <Modal
                size="lg"
                editable={true}
                style={{ backgroundColor: "transparent" }}
                isOpen={this.state.orderModalVisible}
                toggle={this.toggleModal}
              >
                <ImageCard image={this.state.image} goBack={this.toggleModal} />
              </Modal>
              <ReactTable
                data={this.state.stocks}
                filterable
                columns={[
                  {
                    Header: "Product Name",
                    id: "productName",
                    accessor: stock =>
                      stock.node.sku.quantity == null
                        ? stock.node.sku.product.category.name +
                          " - " +
                          stock.node.referenceName
                        : stock.node.sku.product.category.name +
                          " - " +
                          stock.node.referenceName +
                          " - " +
                          stock.node.sku.quantity,
                    filterMethod: (filter, row) => {
                      return row.productName
                        .toLowerCase()
                        .includes(filter.value.toLowerCase());
                    }
                  },
                  {
                    Header: "Image source",
                    id: "imageSource",
                    accessor: stock => stock.node.sku.product.imageSource,
                    filterMethod: (filter, row) => {
                      if (row.imageSource != null) {
                        return row.imageSource
                          .toLowerCase()
                          .includes(filter.value.toLowerCase());
                      }
                    }
                  },
                  {
                    Header: "Images",
                    id: "images",
                    accessor: stock => stock,

                    Cell: row => (
                      <img
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain"
                        }}
                        alt ={''}
                        src={row.value.node.sku.product.image}
                        onClick={() => {
                          this.setState({
                            image: row.value.node.sku.product.image,
                            orderModalVisible: true
                          });
                        }}
                      />
                    )
                  },
                  {
                    Header: "ImgApproved",
                    id: "imageApproved",
                    accessor: stock => stock,
                    maxWidth: 100,
                    Cell: row => (
                      <Switch
                        onChange={(checked, event, id) => {
                          this.toggleImageapproved(JSON.parse(id), checked);
                        }}
                        checked={row.value.node.sku.product.imageApproved}
                        id={JSON.stringify(row.value)}
                      />
                    )
                  }
                ]}
                defaultPageSize={20}
                className="-striped -highlight"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  renderStorePicker = () => {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      return (
        <div>
          <ButtonDropdown
            isOpen={this.state.dropdownOpen}
            toggle={() => {
              this.setState({ dropdownOpen: !this.state.dropdownOpen });
            }}
          >
            <DropdownToggle caret>
              {this.state.selectedStore
                ? this.state.selectedStore.name
                : "Fetching stores.."}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem header>
                Choose a store to adjust inventory
              </DropdownItem>
              {this.state.stores.map(store => (
                <DropdownItem
                  key={store.node.id}
                  onClick={() => {
                    this.storeSelected(store.node);
                  }}
                >
                  {store.node.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      );
    }

    return <div />;
  };
}

/*
<Table responsive>
    <tbody>
        {
            this.state.stocks.map((stock)=><tr key={stock.node.id}>
                <td>{stock.node.referenceName}</td>
                <td>
                    <Switch
                        onChange={this.handleChange}
                        checked={stock.node.inStock}
                        id="normal-switch"
                    />
                </td>
            </tr>)
        }
    </tbody>
</Table>
 */



// WEBPACK FOOTER //
// ./src/pages/InventoryApprove/InventoryApprove.js